import { IntelTechnologiesSortBy, SortDirection } from '@@types/api.types';
import type { SortingState } from '@tanstack/react-table';

export const DEFAULT_PAGE_SIZE = 25;
export const DEFAULT_SORTING: SortingState = [{ desc: false, id: 'name' }];

const SORT_FIELD_BY_COLUMN_ID: Record<string, IntelTechnologiesSortBy> = {
  category: IntelTechnologiesSortBy.Category,
  company: IntelTechnologiesSortBy.Company,
  mrl: IntelTechnologiesSortBy.Mrl,
  name: IntelTechnologiesSortBy.Name,
  trl: IntelTechnologiesSortBy.Trl,
};

export const deriveSort = (
  sortingState: SortingState,
): { sortBy: IntelTechnologiesSortBy; sortDirection: SortDirection } => {
  const sortItem = sortingState[0];

  return {
    sortBy: sortItem ? SORT_FIELD_BY_COLUMN_ID[sortItem.id] : IntelTechnologiesSortBy.Name,
    sortDirection: sortItem?.desc ? SortDirection.DESC : SortDirection.ASC,
  };
};
